import { render, staticRenderFns } from "./WrapMaterialWorkflowForm.vue?vue&type=template&id=306ac131&scoped=true&lang=html&"
import script from "./WrapMaterialWorkflowForm.vue?vue&type=script&lang=js&"
export * from "./WrapMaterialWorkflowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306ac131",
  null
  
)

export default component.exports